<template>
  <div
    class="body"
    style="background: radial-gradient(circle, rgba(45,46,47,1) 20%, rgba(111,142,148,1) 100%);padding:12% 35% 20% 35%;height: 100vh!important;"
  >
    <div class="vue-template">
      <form>
        <h3>ID</h3>
        <div class="form-group">
          <label>{{ $t("ИДни киритинг") }}</label>
          <input
            type="text"
            ref="focused"
            v-model="code"
            class="form-control form-control-lg"
          />
        </div>

        <button
          type="button"
          class="btn btn-dark btn-lg btn-block"
          @click="Send()"
        >
          {{ $t("Сақлаш") }}
        </button>

        <!-- <p class="forgot-password text-right mt-2 mb-4"></p> -->
        <div class="end">
          <router-link :to="{ path: '/sendsecretcodes' }" style="color: blue!important;">
            {{$t('ИДни унутдингизми')}}?
          </router-link>
                  <router-link :to="{ path: '/registration' }" style="color: blue!important;">
          Регистрация
        </router-link>
        </div>
      </form>
    </div>
  </div>
</template>
<style>
.vue-template form {
  padding: 2% 8%;
  border-radius: 10px;
  background: white;
}

.vs__selected-options {
  max-width: 100% !important;
}
</style>

<script>
export default {
  data() {
    return {
      code: '',
    };
  },
  methods: {
    Focus() {
      if (this.$refs.focused) this.$refs.focused.focus();
    },
    Send() {
      let self = this;
      if (!self.code) {
        self.$store.state.errors = self.$t('ИДни киритинг');
        return;
      }
      // Billing (1C HTTP-service) ga backend PROXY orqali murojaat qilamiz.
      // To'g'ridan-to'g'ri emas: sayt HTTPS, billing HTTP — brauzer "mixed content"
      // deb bloklaydi; bundan tashqari CORS va login/parol fosh bo'lishi muammosi bor.
      // Backend getServerUrl() + Basic auth ni server tomonda hal qiladi.
      axios
        .get("api/v1/registration/get-sms/" + encodeURIComponent(self.code))
        .then(function (response) {
          const d = response.data || {};
          if (d.error === false) {
            self.$router.push({ name: 'Smsaccept', params: { code: self.code } });
          } else {
            self.$store.state.errors = d.message || self.$t('no contact with the site');
          }
        })
        .catch(function () {
          self.$store.state.errors = self.$t('no contact with the site');
        });
    },
  },
  mounted() {
    this.Focus();
  },
};
</script>
